<template>
  <vue-cropper
      ref="cropper"
      :guides="true"
      :view-mode="2"
      drag-mode="crop"
      :auto-crop-area="0.8"
      :min-container-width="320"
      :min-container-height="180"
      :background="true"
      :rotatable="false"
      alt="Image"
      :img-style="{ width: '100%', height: '480px' }"
      :aspect-ratio=320/180
      :src="src"
  ></vue-cropper>
</template>

<script>
import VueCropper from "vue-cropperjs";

export default {
  name: "ImageEditor",
  components: {VueCropper},
  props: {
    src: {
      type: [Object, String],
      default: undefined,
    },
    imageWidth: {
      type: Number,
      default: undefined,
    },
    imageHeight: {
      type: Number,
      default: undefined,
    },
  },
  data() {
    return {
      cropImg: '',
    }
  },
  watch: {
    src: {
      handler(value) {
        const cropper = this.$refs.cropper
        cropper.replace(value)
      },
      immediate: true,
    },
  },
  methods: {
    getImage() {
      const cropper = this.$refs.cropper
      return cropper
          .getCroppedCanvas({
            width: this.imageWidth,
            height: this.imageHeight,
          })
          .toDataURL('image/png')
    },
  },
}
</script>

<style scoped>

</style>